import {
  type IntegrationNameEnum,
  IntegrationNames,
} from '@webapp/platform/integrations/entities/enums/IntegrationNameEnum'

// Keys are `field_destination` strings from FieldMapping API contract
// (see IntegrationMappingFieldDestination in @webapp/models/enums); values are
// the corresponding source `value` returned by a sourceMappingRegistry build
// step. Consumers in the components layer add type-safe lookup on top.
export type DefaultMappingSourceConfig = Record<string, string>

export type DefaultMappingSourceRegistry = Partial<
  Record<IntegrationNameEnum, DefaultMappingSourceConfig>
>

const mergeNetSuiteConfig: DefaultMappingSourceConfig = {
  item_description: 'item_description',
}

const mergeQuickBooksOnlineConfig: DefaultMappingSourceConfig = {
  Description: 'item_description',
}

export const defaultMappingSourceRegistry: DefaultMappingSourceRegistry = {
  [IntegrationNames.MERGE_NETSUITE]: mergeNetSuiteConfig,
  [IntegrationNames.MERGE_QUICKBOOKS_ONLINE]: mergeQuickBooksOnlineConfig,
}
